<template>
  <div class="container">
    <div class="section">
      <div class="row">
        <div class="col s12 center-align">
          <h1 class="blue-text text-darken-4">Impulsa Tu Negocio con Soluciones Tecnológicas Inteligentes</h1>
          <p class="grey-text text-darken-2">
            Como consultor en <strong>innovación</strong> IT, arquitecto de sistemas y desarrollador full-stack, ayudo a empresas como la tuya a resolver desafíos digitales, conectando estrategia de
            negocio, diseño de soluciones y ejecución técnica para resolver desafíos críticos y acelerar el crecimiento de tu empresa.
            <br />
            Olvídate de la complejidad técnica; enfócate en crecer mientras yo me encargo de lo que sé hacer mejor.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col s12 m6">
          <h5 class="blue-text text-darken-3">Soluciones que Generan Impacto Real</h5>
          <p>
            Transformo problemas empresariales en oportunidades de crecimiento, como reducir costos operativos en un 30% o aumentar la productividad, diferenciándome de la competencia con un enfoque
            en resultados medibles y atención personalizada.
          </p>
        </div>
        <div class="col s12 m6">
          <h5 class="blue-text text-darken-3">Por Qué Elegirme como Socio Estratégico</h5>
          <p>
            Con años de experiencia en IT, ofrezco valor agregado al alinear la tecnología con tus objetivos de negocio, asegurando proyectos entregados a tiempo y con escalabilidad futura. Ideal para
            empresas buscando talento versátil o freelancers confiables.
          </p>
        </div>
        <div class="col s12 m6">
          <h5 class="blue-text text-darken-3">Estrategia + Ejecución</h5>
          <p>Desde la visión hasta la entrega. Defino la arquitectura correcta, priorizo valor y lidero la implementación con foco en ROI.</p>
        </div>
        <div class="col s12 m6">
          <h5 class="blue-text text-darken-3">Innovación que Impacta</h5>
          <p>Aplico <strong>Lean Startup</strong> y <strong>Design Thinking</strong> para validar rápido, reducir riesgos y convertir ideas en productos.</p>
        </div>
      </div>
      <div class="row center">
        <a href="/contact" class="waves-effect waves-light btn blue darken-2 white-text"><i class="material-icons left">business</i>Contrátame para Tu Proyecto</a>
      </div>
    </div>
  </div>
</template>
